// expose any components referenced directly from server side
import ReactSelect from 'react-select'

import ExternalLinkAlt from 'components/ui/icons/fa/ExternalLinkAlt'
import MeetingRelayWrapper from 'components/meetings/RelayWrapper'
import SideBarOrgSelect from './SideBar/islands/OrgSelectIsland'
import SideBarAgendaItemOpener from './SideBar/islands/AgendaItemOpenerIsland'
import SideBarProposalOpener from './SideBar/islands/ProposalOpenerIsland'
import SearchBox from './SearchBox'
import AsyncBanners from './banners/AsyncBanners'
import OfflineBanner from './banners/OfflineBanner'
import FlashNotifications from './banners/FlashNotifications'
import AiChat from './ai/AiChat'
import InputWithAiSuggest from './ai/AiSuggest/InputWithAiSuggest'

import AppLink from './ui/AppLink'
import Age from './ui/Age'
import CheckboxOutline from './ui/icons/md/CheckboxOutline'
import FrogTipBox from './ui/FrogTipBox'
import DefinitionTooltip from './ui/DefinitionTooltip'
import PremiumCallout from './ui/PremiumCallout'
import Download from './ui/icons/fa/Download'
import HammerAndWrench from './ui/icons/HammerAndWrench'
import HolacracyMark from './ui/icons/HolacracyMark'
import HolacracyMarkBlue from './ui/icons/HolacracyMarkBlue'
import NoItemsMessage from './ui/NoItemsMessage'
import NoteIcon from './ui/icons/md/Note'
import ToggleOn from './ui/icons/md/ToggleOn'
import ToggleOff from './ui/icons/md/ToggleOff'
import RailsSelect from './ui/forms/RailsSelect/StaticRailsSelect'
import RailsRoleSelect from './ui/forms/RailsRoleSelect'
import RailsDatePicker from './ui/forms/RailsDatePicker'
import RailsProjectSelect from './ui/forms/RailsProjectSelect'
import RailsSubmitButton from './ui/RailsSubmitButton'
import RailsWYSIWYG from './ui/forms/RailsWYSIWYG'
import AdminFilterPeopleDropdown from './ui/AdminFilterPeopleDropdown'

import ConfigureJiraSection from './integrations/ConfigureJiraSection'
import TensionInfo from './tensions/ui/TensionInfo'

import DefaultTabs from './DefaultTabs'

import TensionProcessContainer from './tensions/TensionProcessContainer'

// Lazy loaded chunks
import PersonTags from './ProfileSettings/Tags/index.lazy'
import TagHistoryPage from './pages/TagHistory/index.lazy'
import TagPage from './pages/Tag/index.lazy'
import OrgNavApp from './OrgNav/OrgNavApp/index.lazy'
import GraphqlExplorer from './GraphqlExplorer/index.lazy'
// ^ Lazy loaded chunks

import GoalsDateRange from './pages/Goals/GoalsDateRange'
import InvitationAcceptedPage from './pages/InvitationAcceptedPage'

import PrintableGovernance from './reports/PrintableGovernance'

import Constitution from './organizationSettings/Constitution'
import OrganizationHistory from './organizationSettings/OrganizationHistory'
import RoleTemplates from './organizationSettings/RoleTemplates'

import About from './ProfileSettings/About'
import ShepherdTour from './tours/ShepherdTour'

const tours = {
  ShepherdTour,
}

const banners = {
  FlashNotifications,
  AsyncBanners,
  OfflineBanner,
}

const meetings = {
  MeetingRelayWrapper,
}

const ui = {
  DefinitionTooltip,
  FrogTipBox,
  PremiumCallout,
  AppLink,
  NoItemsMessage,
  Age,
  RailsDatePicker,
  RailsProjectSelect,
  RailsSelect,
  RailsRoleSelect,
  RailsSubmitButton,
  RailsWYSIWYG,
  ReactSelect,
  AdminFilterPeopleDropdown,
  SearchBox,
}

const ai = {
  AiChat,
  InputWithAiSuggest,
}

const icons = {
  CheckboxOutline,
  Download,
  HammerAndWrench,
  HolacracyMark,
  HolacracyMarkBlue,
  Note: NoteIcon,
  ToggleOff,
  ToggleOn,
  ExternalLinkAlt,
}

const organizationSettings = {
  Constitution,
  RoleTemplates,
  OrganizationHistory,
}

const profileSettings = {
  PersonTags,
  About,
}

const reports = {
  PrintableGovernance,
}

export default {
  DefaultTabs,
  TensionInfo,
  banners,
  meetings,
  ai,
  tours,
  ConfigureJiraSection,
  OrgNavApp,
  SideBarOrgSelect,
  SideBarAgendaItemOpener,
  SideBarProposalOpener,
  TagHistoryPage,
  TagPage,
  ui,
  icons,
  organizationSettings,
  TensionProcessContainer,
  GraphqlExplorer,
  profileSettings,
  reports,
  InvitationAcceptedPage,
  GoalsDateRange,
}
